const locations = (width = 480, height = 720) => {
  const x = {
    l4: `${width * 0.13}px`, // 0,1458
    l3: `${width * 0.2}px`, // 0,1458
    l2: `${width * 0.2583}px`, // 0,2583
    l1: `${width * 0.3375}px`, // 0,3375
    c: `${width * 0.453}px`, // 0,4458
    r1: `${width * 0.566}px`, // 0,5541
    r2: `${width * 0.6333}px`, // 0,6333
    r3: `${width * 0.7}px`, // 0,7541
    r4: `${width * 0.775}px`, // 0,7541
  }
  const y = {
    t5: `${height * 0.09}px`, // 0,0833
    t4: `${height * 0.2083}px`, // 0,2083
    t3: `${height * 0.29}px`, // 0,275
    t2: `${height * 0.34}px`, // 0,3916
    t1: `${height * 0.4}px`, // 0,3916
    c: `${height * 0.439}px`, // 0,3916
    b1: `${height * 0.515}px`, // 0,525‬
    b2: `${height * 0.56}px`, // 0,6666
    b3: `${height * 0.62}px`, // 0,8333
    b4: `${height * 0.662}px`, // 0,8333
    b5: `${height * 0.825}px`, // 0,8333
  }
  return {
    '4-4-2': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,
      LI: `${x.l4}, ${y.b2}`,
      DFI: `${x.l1}, ${y.b3}`,
      DFD: `${x.r1}, ${y.b3}`,
      LD: `${x.r4}, ${y.b2}`,
      // Midfielder
      MOI: `${x.l4}, ${y.t3}`,
      MI: `${x.l1}, ${y.t1}`,
      MD: `${x.r1}, ${y.t1}`,
      MOD: `${x.r4}, ${y.t3}`,
      // Offensive
      DI: `${x.l1}, ${y.t5}`,
      DD: `${x.r1}, ${y.t5}`,
    },
    '4-3-1-2': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      LI: `${x.l4}, ${y.b2}`,
      DFI: `${x.l1}, ${y.b3}`,
      DFD: `${x.r1}, ${y.b3}`,
      LD: `${x.r4}, ${y.b2}`,

      MI: `${x.l3}, ${y.t2}`,
      MC: `${x.c}, ${y.c}`,
      MD: `${x.r3}, ${y.t2}`,

      MCO: `${x.c}, ${y.t3}`,

      DI: `${x.l1}, ${y.t5}`,
      DD: `${x.r1}, ${y.t5}`,
    },
    '4-3-3': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      LI: `${x.l4}, ${y.b2}`,
      DFI: `${x.l1}, ${y.b3}`,
      DFD: `${x.r1}, ${y.b3}`,
      LD: `${x.r4}, ${y.b2}`,
      // Midfielder
      MI: `${x.l3}, ${y.t2}`,
      MC: `${x.c}, ${y.c}`,
      MD: `${x.r3}, ${y.t2}`,
      // Offensive
      DI: `${x.l4}, ${y.t4}`,
      DD: `${x.r4}, ${y.t4}`,

      DC: `${x.c}, ${y.t5}`,
    },
    '4-2-3-1': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      LI: `${x.l4}, ${y.b2}`,
      DFI: `${x.l1}, ${y.b3}`,
      DFD: `${x.r1}, ${y.b3}`,
      LD: `${x.r4}, ${y.b2}`,

      MDI: `${x.l1}, ${y.c}`,
      MDD: `${x.r1}, ${y.c}`,

      MOI: `${x.l4}, ${y.t3}`,
      MCO: `${x.c}, ${y.t3}`,
      MOD: `${x.r4}, ${y.t3}`,

      DC: `${x.c}, ${y.t5}`,
    },
    '3-4-3': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      DFI: `${x.l2}, ${y.b2}`,
      DFC: `${x.c}, ${y.b2}`,
      DFD: `${x.r2}, ${y.b2}`,

      // Midfielder
      MOI: `${x.l4}, ${y.t2}`,
      MI: `${x.l1}, ${y.t1}`,
      MD: `${x.r1}, ${y.t1}`,
      MOD: `${x.r4}, ${y.t2}`,

      DI: `${x.l4}, ${y.t4}`,
      DC: `${x.c}, ${y.t5}`,
      DD: `${x.r4}, ${y.t4}`,
    },
    '5-3-2': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      LI: `${x.l4}, ${y.b1}`,
      DFI: `${x.l2}, ${y.b3}`,
      DFC: `${x.c}, ${y.b3}`,
      DFD: `${x.r2}, ${y.b3}`,
      LD: `${x.r4}, ${y.b1}`,

      // Midfielder
      MI: `${x.l2}, ${y.t2}`,
      MC: `${x.c}, ${y.t1}`,
      MD: `${x.r2}, ${y.t2}`,

      DI: `${x.l1}, ${y.t4}`,
      DD: `${x.r1}, ${y.t4}`,
    },
    '3-5-2': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      DFI: `${x.l2}, ${y.b3}`,
      DFC: `${x.c}, ${y.b3}`,
      DFD: `${x.r2}, ${y.b3}`,

      // Midfielder
      MOI: `${x.l4}, ${y.t3}`,
      MI: `${x.l2}, ${y.c}`,
      MC: `${x.c}, ${y.c}`,
      MD: `${x.r2}, ${y.c}`,
      MOD: `${x.r4}, ${y.t3}`,

      DI: `${x.l1}, ${y.t5}`,
      DD: `${x.r1}, ${y.t5}`,
    },
    '5-4-1': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      LI: `${x.l4}, ${y.b1}`,
      DFI: `${x.l2}, ${y.b3}`,
      DFC: `${x.c}, ${y.b4}`,
      DFD: `${x.r2}, ${y.b3}`,
      LD: `${x.r4}, ${y.b1}`,

      // Midfielder
      MOI: `${x.l4}, ${y.t3}`,
      MI: `${x.l1}, ${y.c}`,
      MD: `${x.r1}, ${y.c}`,
      MOD: `${x.r4}, ${y.t3}`,

      DC: `${x.c}, ${y.t5}`,
    },
    '3-3': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      DFI: `${x.l2}, ${y.b2}`,
      DFC: `${x.c}, ${y.b3}`,
      DFD: `${x.r2}, ${y.b2}`,

      // Midfielder
      MI: `${x.l2}, ${y.t3}`,
      MC: `${x.c}, ${y.t2}`,
      MD: `${x.r2}, ${y.t3}`,
    },
    '3-1-2': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      DFI: `${x.l2}, ${y.b2}`,
      DFC: `${x.c}, ${y.b3}`,
      DFD: `${x.r2}, ${y.b2}`,

      // Midfielder
      MI: `${x.l2}, ${y.t4}`,
      MC: `${x.c}, ${y.t1}`,
      MD: `${x.r2}, ${y.t4}`,
    },
    '3-2-1': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      DFI: `${x.l2}, ${y.b2}`,
      DFC: `${x.c}, ${y.b3}`,
      DFD: `${x.r2}, ${y.b2}`,

      // Midfielder
      MI: `${x.l2}, ${y.t1}`,
      MC: `${x.c}, ${y.t3}`,
      MD: `${x.r2}, ${y.t1}`,
    },
    '4-2': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      LI: `${x.l3}, ${y.b2}`,
      DFI: `${x.l1}, ${y.b4}`,
      DFD: `${x.r1}, ${y.b4}`,
      LD: `${x.r3}, ${y.b2}`,
      // Midfielder
      MI: `${x.l1}, ${y.t1}`,
      MD: `${x.r1}, ${y.t1}`,
    },
    '2-2-2': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      DFI: `${x.l1}, ${y.b3}`,
      DFD: `${x.r1}, ${y.b3}`,
      // Midfielder
      MI: `${x.l1}, ${y.t1}`,
      MD: `${x.r1}, ${y.t1}`,

      MOI: `${x.l3}, ${y.t3}`,
      MOD: `${x.r3}, ${y.t3}`,
    },
    '2-3-1': {
      // Defensive
      POR: `${x.c}, ${y.b5}`,

      DFI: `${x.l1}, ${y.b2}`,
      DFD: `${x.r1}, ${y.b2}`,
      // Midfielder
      MI: `${x.l2}, ${y.t2}`,
      MC: `${x.c}, ${y.t1}`,
      MD: `${x.r2}, ${y.t2}`,

      MCO: `${x.c}, ${y.t4}`,
    },
  }
}
export default locations
